<template>
  <common-query :query="query" @query="onClickQuery">
    <el-form-item label="交易流水号">
      <el-input v-model="query.id" placeholder="请输入" />
    </el-form-item>
    <el-form-item label="商户名称">
      <el-input v-model="query.merName" placeholder="请输入" />
    </el-form-item>
    <el-form-item label="商户号">
      <el-input v-model="query.merId" placeholder="请输入" />
    </el-form-item>
    <el-form-item label="商户拓展人员">
      <el-input v-model="query.merExpandUserName" placeholder="请输入" />
    </el-form-item>
    <el-form-item label="支付账号">
      <el-input v-model="query.cardNo" placeholder="请输入" />
    </el-form-item>
    <el-form-item label="供应商号">
      <el-input v-model="query.supNo" placeholder="请输入" />
    </el-form-item>
    <el-form-item label="供应商名称">
      <el-input v-model="query.supName" placeholder="请输入" />
    </el-form-item>
    <el-form-item label="供应商拓展人员">
      <el-input v-model="query.supExpandUserName" placeholder="请输入" />
    </el-form-item>
    <el-form-item label="受理账号">
      <el-input v-model="query.terminalNo" placeholder="请输入" />
    </el-form-item>
    <el-form-item label="交易类型">
      <common-select v-model="query.tradeTp" :list="tradeTp" filterable />
    </el-form-item>
    <el-form-item label="收单机构">
      <common-select v-model="query.companyId" :list="companyList" filterable />
    </el-form-item>
    <el-form-item label="城市服务商">
      <common-select v-model="query.serId" :list="serviceList" filterable />
    </el-form-item>
    <el-form-item label="渠道">
      <common-select v-model="query.bankId" :list="channelList" filterable />
    </el-form-item>
    <el-form-item label="客服介入">
      <common-select
        v-model="query.applyCustomer"
        :list="applyCustomer"
        filterable
      />
    </el-form-item>
    <el-form-item label="交易状态">
      <common-select v-model="query.state" :list="state" filterable />
    </el-form-item>
    <el-form-item label="清算状态">
      <common-select v-model="query.settleSt" :list="settleSt" filterable />
    </el-form-item>
    <el-form-item label="交易来源">
      <common-select
        v-model="query.orderSource"
        :list="orderSource"
        filterable
      />
    </el-form-item>
    <el-form-item label="交易方式">
      <common-select v-model="query.tradeWay" :list="tradeWay" filterable />
    </el-form-item>
    <el-form-item label="交易时间" class="auto-width">
      <template v-if="!filterTimes">
        <time-picker v-model="query.createStartTime" />
        <span class="middle-text">至</span>
        <time-picker v-model="query.createEndTime" />
      </template>
      <template v-else>
        <date-picker v-model="query.startTime" time />
        <span class="middle-text">至</span>
        <date-picker v-model="query.endTime" time />
      </template>
    </el-form-item>
    <el-form-item label="支付操作人">
      <el-input
        v-model="query.merOperatorName"
        placeholder="请输入"
        maxlength="15"
      />
    </el-form-item>
    <el-form-item label="受理操作人">
      <el-input
        v-model="query.supOperatorName"
        placeholder="请输入"
        maxlength="15"
      />
    </el-form-item>
  </common-query>
</template>

<script>
export default {
  props: {
    query: {
      type: Object,
      default() {
        return {}
      },
      comment: '查询数据条件'
    },
    filterTimes: Boolean,
    state: Array,
    tradeTp: Array,
    settleSt: Array,
    companyList: Array,
    channelList: Array,
    serviceList: Array,
    orderSource: Array,
    applyCustomer: Array,
    tradeWay: Array
  },

  methods: {
    onClickQuery() {
      this.$emit('query', this.query)
    }
  }
}
</script>
